import UAParser from 'ua-parser-js';

let parser: UAParser;

try {
    parser = new UAParser();
} catch {}

const device = parser?.getDevice();
const isTablet = device?.type === 'tablet';
const isMobile = device?.type === 'mobile';

export default {
    isTablet,

    isMobile,

    isTouchDevice: isMobile || isTablet,

    isIOS: ['iOS', 'iPadOS'].includes(parser?.getOS()?.name),

    browser: parser?.getBrowser(),

    api: parser,
};
